/**
 * Shared tenant constants + predicates, used by the list, the create modal,
 * and the detail page. Kept out of the page files so the two surfaces can't
 * drift on what counts as reserved or which statuses exist.
 */
import type { TenantType, TenantStatus } from '../../../api/tenantsApi';

export const TENANT_TYPES: TenantType[] = ['public', 'school', 'teacher', 'organization', 'personal'];
export const TENANT_STATUSES: TenantStatus[] = ['active', 'suspended', 'archived'];
export const TENANT_ID_REGEX = /^[a-z0-9-]{1,32}$/;

/** Platform-owned ids. They exist for every deployment and can't be archived,
 *  hard-deleted, restatused, or reparented. */
export const RESERVED_IDS = new Set(['0', 'platform']);

/** The reserved tenant whose settings are the defaults every other tenant
 *  inherits. It has no members, so it has no gate overrides. */
export const PLATFORM_TENANT_ID = 'platform';

export function isReserved(id: string): boolean {
    return RESERVED_IDS.has(id);
}

export function statusVariant(status: TenantStatus): 'success' | 'warning' | 'default' {
    if (status === 'active') return 'success';
    if (status === 'suspended') return 'warning';
    return 'default';
}
